import { useDayjs, useState } from '#imports'

const monotonicNow = () => performance.timeOrigin + performance.now()

// Client only: server time minus monotonic time, so device clock changes don't move `now()`.
let offset: number | undefined

export const useClock = () => {
    const dayjs = useDayjs()
    const clock = useState<string>('serverTime', () => dayjs.tz().toISOString())

    if (import.meta.client) {
        offset ??= dayjs(clock.value).valueOf() - monotonicNow()
    }

    function setClock(datetime: string) {
        clock.value = datetime
    }

    function now(): number {
        return import.meta.client ? monotonicNow() + offset! : dayjs().valueOf()
    }

    /** Takes a server time sampled at `performance.now() === sampledAt`, then publishes it to `clock`. */
    function setServerTime(serverNow: number, sampledAt: number) {
        const nextOffset = serverNow - (performance.timeOrigin + sampledAt)
        // Throws on an out-of-range time, before anything is committed.
        clock.value = dayjs(monotonicNow() + nextOffset).toISOString()
        offset = nextOffset
    }

    return {
        clock,
        setClock,
        now,
        setServerTime,
    }
}
